import ReturnsTable from './ReturnsTable';

export default ReturnsTable;
